import React from 'react';
import { X } from 'react-bootstrap-icons';
import FileUpload from "../../utils/FileUpload";

interface ExcelUploadInfoProps {
    onUpload: (file: File) => Promise<any>;
    onUploadSuccess?: (data: any) => void;
    onUploadError?: (error: string) => void;
    onClose?: () => void;
    className?: string;
}

export default function ExcelUploadInfo({
    onUpload,
    onUploadSuccess,
    onUploadError,
    onClose,
    className = ''
}: ExcelUploadInfoProps) {
    return (
        <div className={`excel-upload-container p-4 border rounded bg-light mb-3 position-relative ${className}`}>
            {onClose && (
                <button
                    type="button"
                    className="btn-close position-absolute top-0 end-0 m-3"
                    aria-label="Закрыть"
                    onClick={onClose}
                    style={{ zIndex: 10 }}
                />
            )}

            <div className="upload-info mb-4">
                <p className="mb-2">
                    Поддерживается загрузка Excel файлов с расширением .xlsx или .xls.
                </p>
                <p className="mb-2">
                    Файл должен содержать 4 колонки: <strong>Код | Артикул | Название | Количество</strong>.
                </p>
                <p className="mb-2">
                    После загрузки Вы увидите складские остатки и актуальную стоимость для вашего тарифа.
                </p>
                <p className="mb-2">
                    Название продуктов заполнять не обязательно (можно оставить колонку пустой).
                    Главное - это наличие кода, артикула и количество позиций.
                </p>
                <p className="mb-0">
                    Образец файла можно скачать <a href="/files/sample.xlsx" target="_blank" rel="noopener noreferrer">здесь</a>.
                </p>
            </div>

            <FileUpload
                onUpload={onUpload}
                onUploadSuccess={onUploadSuccess}
                onUploadError={onUploadError}
            />
        </div>
    );
}
